import { Row, Col, Card } from "react-bootstrap";
import { useState, useEffect } from "react";

const FMP_RATIOS_TTM_URL = "https://financialmodelingprep.com/stable/ratios-ttm";

export default function KeyMetricsSection({ ticker }) {
  const [ratiosTTM, setRatiosTTM] = useState(null);
  const metrics = [
    { label: "PER", value: Number(ratiosTTM?.priceToEarningsRatioTTM).toFixed(2) },
    { label: "PBR", value: Number(ratiosTTM?.priceToBookRatioTTM).toFixed(2) },
    { label: "PSR", value: Number(ratiosTTM?.priceToSalesRatioTTM).toFixed(2) },
    { label: "배당수익률", value: (Number(ratiosTTM?.dividendYieldTTM) * 100).toFixed(2) + "%" },
    { label: "배당성향", value: (Number(ratiosTTM?.dividendPayoutRatioTTM) * 100).toFixed(2) + "%" },
    { label: "부채비율", value: (Number(ratiosTTM?.debtToEquityRatioTTM) * 100).toFixed(2) + "%" },
  ];
  useEffect(() => {
    const url = `${FMP_RATIOS_TTM_URL}?symbol=${ticker}&apikey=${process.env.REACT_APP_FINANCIAL_API_KEY}`;
    const fetchRatiosTTM = async () => {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error("Failed to fetch ratios TTM");
        }
        const data = await response.json();
        setRatiosTTM(data[0]);
      } catch (error) {
        console.error("Error fetching ratios TTM:", error);
      }
    };

    if (ticker) {
      fetchRatiosTTM();
    }
  }, [ticker]);
  return (
    <Row className="mb-2">
      {metrics.map((item, index) => (
        <Col xs={4} sm={4} md={2} className="mb-2" key={index}>
          <Card className="h-100 border-0 shadow-sm">
            <Card.Body className="p-2 p-md-3 d-flex flex-column align-items-center justify-content-center">
              <div
                className="text-center mb-1 text-secondary"
                style={{
                  fontWeight: 600,
                  fontSize: "clamp(1.0rem, 2.5vw, 1.2rem)",
                  wordBreak: "keep-all",
                  letterSpacing: "-0.5px" // 긴 글자를 위해 자간 살짝 축소
                }}
              >
                {item.label}
              </div>
              <div
                className="text-center text-dark"
                style={{
                  fontWeight: 600,
                  fontSize: "clamp(0.9rem, 3vw, 1.1rem)"
                }}
              >
                {item.value}
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}
